import Anchor from 'models/application/anchor/Anchor';

export default class InternalDynamicAnchor extends Anchor {
	_category = 'internal-dynamic';
}
